<template>
	<rmp-dialog max-width="620" :title="tc('dialogs.digitalSignatureInstructions.title')"
				:value="value" @update:value="emit('update:value', $event)">
		<template #content>
			<div class="d-flex flex-column pt-4" style="row-gap: 32px">
				<v-row class="secondary--text font-weight-bold ma-0">
					<v-col style="max-width: fit-content" class="pa-0 mr-2">
						<span>1</span>
					</v-col>
					<v-col class="d-flex flex-column pa-0">
						<span>Не подключен носитель</span>
						<span class="grey--text text--darken-1 font-weight-regular">
							Подключите к компьютеру USB-ключ или смарт-карту
						</span>
					</v-col>
				</v-row>
				<v-row class="secondary--text font-weight-bold ma-0">
					<v-col style="max-width: fit-content" class="pa-0 mr-2">
						<span>2</span>
					</v-col>
					<v-col class="d-flex flex-column pa-0">
						<span>Не установлен плагин</span>
						<span class="grey--text text--darken-1 font-weight-regular">
							<rmp-link blank href="https://www.cryptopro.ru/products/cades/plugin"
									  text="Воспользуйтесь инструкцией по установке"></rmp-link>
							<span>, перезапустите браузер и попробуйте снова</span>
						</span>
					</v-col>
				</v-row>
				<v-row class="secondary--text font-weight-bold ma-0">
					<v-col style="max-width: fit-content" class="pa-0 mr-2">
						<span>3</span>
					</v-col>
					<v-col class="d-flex flex-column pa-0">
						<span>Не установлена программа криптопровайдер</span>
						<span class="grey--text text--darken-1 font-weight-regular">
							<span>На компьютере должна быть установленна специальная программа (например, </span>
							<rmp-link class="ml-1" blank href="https://cryptopro.ru/products/csp" text="КриптоПро CSP"></rmp-link>
							<span>)</span>
						</span>
					</v-col>
				</v-row>
				<v-row class="secondary--text font-weight-bold ma-0">
					<v-col style="max-width: fit-content" class="pa-0 mr-2">
						<span>4</span>
					</v-col>
					<v-col class="d-flex flex-column pa-0">
						<span>Не установлена программа криптопровайдер</span>
						<span class="grey--text text--darken-1 font-weight-regular">
							<span>Убедитесь в корректности работы плагина, перейдя по</span>
							<rmp-link class="ml-1" blank href="https://www.cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html" text="ссылке"></rmp-link>
						</span>
					</v-col>
				</v-row>
			</div>
		</template>
	</rmp-dialog>
</template>

<script setup lang="ts">
import RmpDialog from "@rmp/core/components/dialogs/RmpDialog.vue";
import { useVuetify } from "@rmp/core/plugins/vuetify";
import { useI18n } from "vue-i18n-composable";
import RmpLink from "@rmp/core/components/common/RmpLink.vue";

const { tc } = useI18n();

export interface Props {
	value: boolean;
}

const vuetify = useVuetify();

const props = defineProps<Props>(
);

const emit = defineEmits<{
	(e: "update:value", value: boolean): void
}>();
</script>
